import { useTranslation } from "react-i18next";
import type { New } from "types";
import CrudEdit from "common/components/Crud/CrudEdit";
import { TableColumn } from "common/components/DataTable/DataTable";
import { CrudHeaderAction } from "common/components/Crud/components/CrudHeader";
import { CrudFilter } from "common/components/Crud/components/CrudFilters";
import CrudList from "common/components/Crud/CrudList";
import { useMemo } from "react";
import useRouter from "common/hooks/use-router";
import NewsForm from "./NewsForm";

function SidebarNewsForm({ ...props }: any) {
  return <CrudEdit collectionName="news" Form={NewsForm} {...props} />;
}

function News() {
  const { t } = useTranslation();
  const { navigate } = useRouter();

  const handleNavigate = (id: any) => {
    navigate(`/news/edit/${id}`);
  };

  const columns: TableColumn<New>[] = useMemo(
    () => [
      {
        field: "image",
        header: t("news.image"),
        renderType: "image",
        style: {
          width: "200px",
        },
      },
      {
        field: "name",
        header: t("news.name"),
        sortable: true,
        renderType: "bold",
      },
    ],
    [t]
  );

  const actions: CrudHeaderAction[] = useMemo(() => {
    return [
      {
        title: t("common.new"),
        icon: "PlusCircleIconSolid",
        action: "openSidebar",
        type: "white",
        className: "flex flex-row-reverse",
      },
    ];
  }, [t]);

  const filters: CrudFilter[] = useMemo(() => {
    return [
      {
        name: "name$containsi",
        label: t("news.name"),
        renderType: "input",
        icon: "MagnifyingGlassIcon",
      },
    ];
  }, [t]);

  return (
    <CrudList
      collectionName="news"
      columns={columns}
      headerActions={actions}
      filters={filters}
      defaultSort="name:ASC"
      canDelete
      canEdit
      formMode="sidebar"
      SidebarFormComponent={SidebarNewsForm}
      onNavigate={handleNavigate}
      actionsHeader=""
      className="pt-2 px-4"
    />
  );
}

export default News;
